import React, { useContext } from 'react';

import SITE_PATHS from '../../config/sitePaths';
import agreeingToTerms from './agreeingToTerms';
import ParagraphWithHeading from '../../components/ParagraphWithHeading';
import Text, { getText } from '../../components/Text';
import { EmbeddableConfigContext } from '../../config/EmbeddableContext';
import { LanguageContext } from '../../config/LanguageContext';

import './style.scss';

export default function Agreement(props) {
  const { onAgreementAccepted, history, isGuestUser } = props;
  const paragraphs = [];
  const { language } = useContext(LanguageContext);

  const onAgreeingToTerms = () => {
    agreeingToTerms(false, isGuestUser, language)
      .then((guestUserData) => {
        onAgreementAccepted(guestUserData);
      })
      .catch(console.error); // eslint-disable-line no-console
  };

  const addParagraph = (key) => {
    paragraphs.push({
      key,
      heading: getText(key),
      body: getText(`${key} content`),
    });
  };

  addParagraph('How can this help me');
  addParagraph('Why do you need my data?');
  addParagraph('How is my data being used?');
  addParagraph('What security is there on my data?');
  addParagraph('What if I don\'t have an active online presence or don’t have any social media accounts?');

  return (
    <EmbeddableConfigContext.Consumer>
      {(embeddedContext) => {
        if (embeddedContext.enabledFeatures.tswebEnabled) {
          history.push(SITE_PATHS.LOAN, { isEmbedded: true });
          // Using next screen still needs to know a head of time if the app is embedded or not.
          return null;
        }

        return (
          <div className="container">
            <h3><Text value="Terms and Conditions" /></h3>
            <div className="agreement">
              <p><Text value="Agree to Terms" /></p>
              <div className="row">
                <div className="col d-flex justify-content-center">
                  <a href="/terms" aria-label="Terms of Use"><Text value="Terms of Use" /></a>
                </div>
                <div className="col d-flex justify-content-center">
                  <a href="/privacy" aria-label="Privacy Policy"><Text value="Privacy Policy" /></a>
                </div>
              </div>

              <div className="d-flex w-100 flex-row justify-content-center">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={onAgreeingToTerms}
                  data-cy="nextButton"
                  aria-label="Accept Terms & Conditions"
                >
                  <Text value="Accept" />
                </button>
              </div>
            </div>
            <div className="faq">
              <h4><Text value="Frequently Asked Questions" /></h4>
              {
                paragraphs.map((p) => (
                  <ParagraphWithHeading
                    key={p.key}
                    heading={p.heading}
                    body={p.body}
                  />
                ))
              }
            </div>
          </div>
        );
      }}
    </EmbeddableConfigContext.Consumer>
  );
}
